import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=731b64f8&scoped=true&lang=pug"
import script from "./Sync.vue?vue&type=script&lang=js"
export * from "./Sync.vue?vue&type=script&lang=js"
import style0 from "./Sync.vue?vue&type=style&index=0&id=731b64f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731b64f8",
  null
  
)

export default component.exports